var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 45.5C12.14 45.5 2.5 35.86 2.5 24C2.5 12.14 12.14 2.5 24 2.5C35.86 2.5 45.5 12.14 45.5 24C45.5 35.86 35.86 45.5 24 45.5ZM24 5.5C13.8 5.5 5.5 13.8 5.5 24C5.5 34.2 13.8 42.5 24 42.5C34.2 42.5 42.5 34.2 42.5 24C42.5 13.8 34.2 5.5 24 5.5Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.5C23.18 27.5 22.5 26.82 22.5 26V16C22.5 15.18 23.18 14.5 24 14.5C24.82 14.5 25.5 15.18 25.5 16V26C25.5 26.82 24.82 27.5 24 27.5Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34C23.74 34 23.48 33.94 23.24 33.84C23 33.74 22.78 33.6 22.58 33.42C22.4 33.22 22.26 33.02 22.16 32.76C22.06 32.52 22 32.26 22 32C22 31.74 22.06 31.48 22.16 31.24C22.26 31 22.4 30.78 22.58 30.58C22.78 30.4 23 30.26 23.24 30.16C23.72 29.96 24.28 29.96 24.76 30.16C25 30.26 25.22 30.4 25.42 30.58C25.6 30.78 25.74 31 25.84 31.24C25.94 31.48 26 31.74 26 32C26 32.26 25.94 32.52 25.84 32.76C25.74 33.02 25.6 33.22 25.42 33.42C25.22 33.6 25 33.74 24.76 33.84C24.52 33.94 24.26 34 24 34Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoEmptyState);
export default __webpack_public_path__ + "static/media/InfoEmptyState.374ce8b1.svg";
export { ForwardRef as ReactComponent };